import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';
const IconRightArrow = ({ width = '16px', height = '16px', viewBox = '0 0 16 16', color = colors.mineShaft }) =>
	<svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
		<path d='M8.5 0L7 1.5L10 4.5H0V6.5H10L7 9.5L8.5 11L14 5.5L8.5 0Z' fill={color} />
	</svg>;

IconRightArrow.propTypes = {
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	viewBox: PropTypes.string,
	color: PropTypes.string
};

export default IconRightArrow;
